<template>
  <Dialog
    width="892px"
    titleAlign="left"
    :title="$$t('create.extend')"
    :subTitle="$$t('create.extend_regeneration_subtitle')"
    :visible="renderData.visible"
    @close="closeDialog"
    mobileRenderType="drawerDialog"
  >
    <div
      class="height-all edit-extend-song flex-column"
      :class="{
        'edit-extend-song-mobile': createRenderType == 'mobile',
      }"
    >
      <div class="edit-extend-song-edit-box">
        <EditSelectSong
          v-if="renderData.ifRender"
          type="extend"
          ref="refSelectSong"
          :url="`${getObjectStorageFullUrl(
            props.item.mp3_url
          )}?type=extendSong`"
          :duration="(props.item.duration_milliseconds ?? 0) / 1000"
          @syncWaveLoadingState="doSyncWaveLoadingState"
        ></EditSelectSong>
      </div>
      <div class="edit-extend-song-lyrics">
        <EditLyric
          :item="props.item"
          :pitem="props.pitem"
          ref="refEditLyric"
          @change="onChangeLyric"
        ></EditLyric>
      </div>
      <div class="edit-extend-song-done-btn-box">
        <div class="edit-extend-song-done-btn">
          <Bubble
            v-if="renderData.disabled"
            effect="dark"
            :content="$$tValue('create.min_n_letters_lyric', { count: 1 })"
            placement="top"
          >
            <Button
              :disabled="renderData.disabled"
              @click="doReGenerate"
              :renderStyle="{
                '--padding': '0',
                '--width': '100%',
                '--height': '48px',
                '--borderRadius': '50px',
                '--fontColor': '#000',
                '--fontSize': '16px',
                '--fontWeight': 'normal',
                '--border': 'none',
                '--background':
                  'linear-gradient(120deg, rgb(79, 222, 255, 1) -1%, rgb(230, 117, 255, 1) 100%)', //#94ADFF
                '--backgroundHover':
                  'linear-gradient(120deg, rgb(79, 222, 255, 0.75) -1%, rgb(230, 117, 255, 0.75) 100%)',
                '--fontColorHover': '#000',
              }"
            >
              {{ $$t("create.extend") }}
            </Button>
          </Bubble>
          <Button
            v-if="!renderData.disabled"
            :disabled="renderData.isLoading || renderData.waveLoading"
            @click="doReGenerate"
            :renderStyle="{
              '--padding': '0',
              '--width': '100%',
              '--height': '48px',
              '--borderRadius': '50px',
              '--fontColor': '#000',
              '--fontSize': '16px',
              '--fontWeight': 'normal',
              '--border': 'none',
              '--background':
                'linear-gradient(120deg, rgb(79, 222, 255, 1) -1%, rgb(230, 117, 255, 1) 100%)', //#94ADFF
              '--backgroundHover':
                'linear-gradient(120deg, rgb(79, 222, 255, 0.75) -1%, rgb(230, 117, 255, 0.75) 100%)',
              '--fontColorHover': '#000',
            }"
          >
            {{ $$t("create.extend") }}
          </Button>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";
import Bubble from "@/components/bubble/bubble.vue";
import Dialog from "@/components/basic/dialog/Dialog.vue";
import Button from "@/components/basic/button/Button.vue";
import EditSelectSong from "@/page/create/editSong/editSelectSong.vue";
import EditLyric from "./editLyric.vue";
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js";

import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  item: {
    type: Object,
    default: null,
  },
  pitem: {
    type: Object,
    default: null,
  },
});
const emits = defineEmits(["update:visible", "reGenerate", "close"]);

const refSelectSong = ref(null);
const refEditLyric = ref(null);
const renderData = reactive({
  visible: props.visible,
  isLoading: false,
  disabled: true,
  waveLoading: false,
  ifRender: true,
});

const doSyncWaveLoadingState = (loading) => {
  renderData.waveLoading = loading;
};

const closeDialog = () => {
  renderData.visible = false;
  emits("close", false);
};
const doReGenerate = () => {
  renderData.isLoading = true;
  emits(
    "reGenerate",
    {
      startTime: refSelectSong.value.getRenerateStartTime(),
      lyrics: refEditLyric.value.getLyrics(),
    },
    () => {
      renderData.isLoading = false;
    }
  );
};

const onChangeLyric = (lyric, count) => {
  renderData.disabled = count < 1;
};

watch(
  () => props.visible,
  (val) => {
    renderData.visible = props.visible;
  }
);

watch(
  () => renderData.visible,
  (val) => {
    emits("update:visible", val);
  }
);

const reRender = () => {
  renderData.ifRender = false;
  nextTick(() => {
    renderData.ifRender = true;
  });
};
const initResizeObserve = () => {
  renderData.resizeObserver = new ResizeObserver(() => {
    if (renderData.winWidth != window.innerWidth) {
      renderData.winWidth = window.innerWidth;
      reRender();
    }
  });
  renderData.resizeObserver?.observe(document.body);
};
onMounted(() => {
  renderData.winWidth = window.innerWidth;
  initResizeObserve();
});
onUnmounted(() => {
  renderData.resizeObserver?.disconnect();
});
</script>
<style lang="scss" scope>
.edit-extend-song {
  margin: 15px 40px 40px 40px;
  .edit-extend-song-lyrics {
    height: 213px;
    margin-top: 20px;
  }
}
.edit-extend-song-done-btn-box {
  padding: 0 32px;
  .edit-extend-song-done-btn {
    margin: 30px auto 0 auto;
    max-width: 400px;
  }
}
.edit-extend-song.edit-extend-song-mobile {
  margin: 15px 16px 16px 16px;
  .edit-extend-song-lyrics {
    height: 280px;
  }
  .edit-extend-song-done-btn-box {
    padding: 0;
    .edit-extend-song-done-btn {
      margin: 28px auto 12px auto;
      max-width: 100%;
      width: 100%;
    }
  }
}
</style>
